import { User, UserManager } from "oidc-client";

/**There should only be one instance of the user manager in the app to prevent accidental double sessions */
export default class UserManagerSingleton {
    private static instance: UserManagerSingleton;

    private readonly _oidcUserManager : UserManager = undefined;

    private constructor(settings : any | null | undefined) {
        this._oidcUserManager = new UserManager(settings);
    }

    public static getInstance(settings ?: any | null | undefined): UserManagerSingleton {
        if (!UserManagerSingleton.instance && settings) {
            UserManagerSingleton.instance = new UserManagerSingleton(settings);
        }

        return UserManagerSingleton.instance;
    }

    getOidcUserManager() {
        return this._oidcUserManager;
    }


}
